import { Link, useLocation } from "react-router-dom";
import { GitCompareArrows, X } from "lucide-react";
import { cn } from "@/lib/cn";
import { MAX_COMPARE, useCompare } from "./store";

/** Floating tray once something is picked for comparison. */
export function CompareTray() {
  const items = useCompare((s) => s.items);
  const remove = useCompare((s) => s.remove);
  const clear = useCompare((s) => s.clear);
  const { pathname } = useLocation();
  if (!items.length || pathname === "/compare") return null;
  return (
    <div
      className="fixed inset-x-0 bottom-[calc(var(--app-bottom)+12px)] z-40 flex justify-center px-4 md:bottom-6"
      role="region"
      aria-label="Compare"
    >
      <div className="glass flex max-w-full items-center gap-3 rounded-full border border-[var(--border-glow)] py-2 pl-4 pr-2 shadow-glow-2">
        <GitCompareArrows className="size-5 shrink-0 text-cyan" aria-hidden />
        <ul className="flex -space-x-2">
          {items.map((i) => (
            <li key={i.slug} className="group relative">
              {i.cover ? (
                <img src={i.cover} alt={i.title} className="size-9 rounded-full border-2 border-void object-cover" />
              ) : (
                <span className="grid size-9 place-items-center rounded-full border-2 border-void bg-elevated text-xs">{i.title[0]}</span>
              )}
              <button
                type="button"
                onClick={() => remove(i.slug)}
                className="absolute -right-1 -top-1 hidden size-4 place-items-center rounded-full bg-danger text-white group-focus-within:grid group-hover:grid"
                aria-label={`Remove ${i.title} from compare`}
              >
                <X className="size-3" aria-hidden />
              </button>
            </li>
          ))}
        </ul>
        <span className="hidden text-sm text-ink-soft sm:inline">
          {items.length}/{MAX_COMPARE}
        </span>
        <Link
          to="/compare"
          className={cn(
            "rounded-full px-4 py-2 text-sm font-medium text-white",
            items.length >= 2 ? "bg-[var(--primary-strong)] shadow-glow-1" : "pointer-events-none bg-fg/10 text-ink-muted",
          )}
          aria-disabled={items.length < 2}
        >
          Compare
        </Link>
        <button
          type="button"
          onClick={clear}
          className="grid size-8 place-items-center rounded-full text-ink-muted hover:bg-fg/5"
          aria-label="Clear compare"
        >
          <X className="size-4" aria-hidden />
        </button>
      </div>
    </div>
  );
}
